import { StepValidationPayload, SubmitFormResponse as SubmitFormResponse, ValidateFormStepResponse } from "wolf/components/organisms/o-heating-form/o-heating-form.types";
import { CustomFieldFieldTypes } from "../../../../model/global";
class HeatingApi implements IHeatingApi {

	async runAsyncValidation(url: string, stepPayload: StepValidationPayload): ReturnType<IHeatingApi['runAsyncValidation']> {
		let endpoint: URL;
		try {
			endpoint = new URL(url)
		} catch (error) {
			throw new Error(error);
		}

		try {
			const resp = await fetch(endpoint.toString(), {
				method: 'POST',
				credentials: 'same-origin',
				body: JSON.stringify(stepPayload),
			});

			const response = (await resp.json()) as ValidateFormStepResponse
			return response

		} catch (error) {
			throw new Error(error);
		}
	}

	async submitFinalForm(url: string, payload: FinalFormPayload): ReturnType<IHeatingApi['submitFinalForm']> {
		let endpoint: URL;
		try {
			endpoint = new URL(url)
		} catch (error) {
			throw new Error(error);
		}

		try {
			const resp = await fetch(endpoint.toString(), {
				method: 'POST',
				// credentials: 'same-origin',
				body: payload.formData,
				// body: JSON.stringify(payload.payload),
			});

			const response = (await resp.json()) as SubmitFormResponse;
			return response

		} catch (error) {
			// console.log(error);
			throw new Error(error);
		}
	}
}

export default new HeatingApi();

export interface IHeatingApi {
	runAsyncValidation: (url: string, stepPayload: any) => Promise<ValidateFormStepResponse>;
	submitFinalForm: (url: string, payload: any) => Promise<SubmitFormResponse>;
}

export interface PostField {
	name: string;
	value: any;
	fieldType: CustomFieldFieldTypes;
	checked?: boolean;
}
export interface FinalFormPayload {
	payload: Record<string, Record<string, PostField>>;
	formData: FormData;
}
